export default "__VITE_ASSET__CG4fJunr__"